import React, { useEffect } from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, useLocation, Navigate } from 'react-router-dom';
import { LanguageProvider } from './context/LanguageContext';
import { FlavourProvider } from './context/FlavourContext';
import { CartProvider } from './context/CartContext';
import { WooProvider } from './context/WooContext';
import { AuthProvider, useAuth } from './context/AuthContext';
import { Toaster } from './components/ui/sonner';
import Header from './components/Header';
import Footer from './components/Footer';
import StickyPurchaseBar from './components/StickyPurchaseBar';
import CartDrawer from './components/CartDrawer';
import Home from './pages/Home';
import About from './pages/About';
import Ingredients from './pages/Ingredients';
import Flavours from './pages/Flavours';
import Reviews from './pages/Reviews';
import Faq from './pages/Faq';
import CountryManagers from './pages/CountryManagers';
import PaymentSuccess from './pages/PaymentSuccess';
import PaymentCancel from './pages/PaymentCancel';
import AdminLogin from './pages/admin/AdminLogin';
import AdminDashboard from './pages/admin/AdminDashboard';
import { getSocialConfig, initPixel } from './lib/social';

function ScrollToTop() {
  const { pathname } = useLocation();
  const first = React.useRef(true);
  useEffect(() => {
    window.scrollTo(0, 0);
    if (!first.current && window.fbq) window.fbq('track', 'PageView');
    first.current = false;
  }, [pathname]);
  return null;
}

function ProtectedRoute({ children }) {
  const { admin } = useAuth();
  if (admin === null) return <div className="min-h-screen bg-[#050505]" />;
  if (!admin) return <Navigate to="/admin/login" replace />;
  return children;
}

function Storefront() {
  useEffect(() => { getSocialConfig().then((c) => initPixel(c.meta_pixel_id)); }, []);
  return (
    <>
      <Header />
      <CartDrawer />
      <StickyPurchaseBar />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/ingredients" element={<Ingredients />} />
          <Route path="/flavours" element={<Flavours />} />
          <Route path="/reviews" element={<Reviews />} />
          <Route path="/faq" element={<Faq />} />
          <Route path="/managers" element={<CountryManagers />} />
          <Route path="/payment/success" element={<PaymentSuccess />} />
          <Route path="/payment/cancel" element={<PaymentCancel />} />
        </Routes>
      </main>
      <Footer />
    </>
  );
}

function App() {
  return (
    <div className="App bg-[#050505] min-h-screen">
      <AuthProvider>
        <LanguageProvider>
          <FlavourProvider>
            <WooProvider>
              <CartProvider>
                <BrowserRouter>
                  <ScrollToTop />
                  <Toaster position="top-center" theme="dark" richColors />
                  <Routes>
                    <Route path="/admin/login" element={<AdminLogin />} />
                    <Route path="/admin" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
                    <Route path="/*" element={<Storefront />} />
                  </Routes>
                </BrowserRouter>
              </CartProvider>
            </WooProvider>
          </FlavourProvider>
        </LanguageProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
